import {
    FETCH_SURVEYS_LIST_FOR_ORG_START,
    FETCH_SURVEYS_LIST_FOR_ORG_SUCCESS,
    FETCH_SURVEYS_LIST_FOR_ORG_FAIL

} from "../../../constants";
import {
    LIST_SURVEY_DATA_BENCHMARK,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { SETTINGS_PAGE_SECTION } from "../../../../../config/tabConstants";

export const fetchSurveysFromTheOrg = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(FETCH_SURVEYS_LIST_FOR_ORG_START, { ...payload })
        );
        return apiBaseInstance
            .post(LIST_SURVEY_DATA_BENCHMARK, {
                ...payload, ...getProjectIdAndOrgId(payload),currentTab: SETTINGS_PAGE_SECTION.SETTINGS_SUB_TABS.ADMINISTRATOR
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_SURVEYS_LIST_FOR_ORG_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb(true, res.data)
            })
            .catch((err) => {
                dispatch(withType(FETCH_SURVEYS_LIST_FOR_ORG_FAIL, { ...err, ...payload }));
                cb && cb(false)
            });
    };
};

